import { Divider, Grid, Row } from 'antd'
import * as React from 'react'

import KCol from '../../UI-Elements/Layout/KCol'
import { FormRecord } from '../Form/typing'

type Props = {
  renderMobileRow?: (record: unknown) => React.ReactNode
  record: FormRecord
}

const KTableRow: React.FC<Props> = ({ record, renderMobileRow, ...others }) => {
  const { md } = Grid.useBreakpoint()
  return (
    <Choose>
      <When condition={!md}>
        <Choose>
          <When condition={renderMobileRow}>
            <Row {...others}>
              <KCol span={24}>{renderMobileRow?.(record)}</KCol>
              <KCol span={24}>
                <Divider />
              </KCol>
            </Row>
          </When>
          <Otherwise>
            <tr {...others} />
          </Otherwise>
        </Choose>
      </When>
      <Otherwise>
        <tr {...others} />
      </Otherwise>
    </Choose>
  )
}

export default KTableRow
